import api from '../api';

export function listClientRequests(params = {}) {
  return api.get('/api/client-requests/', { params });
}

export function createClientRequest(payload) {
  return api.post('/api/client-requests/', payload);
}

export function getClientRequest(id) {
  return api.get(`/api/client-requests/${id}/`);
}

export function patchClientRequest(id, payload) {
  return api.patch(`/api/client-requests/${id}/`, payload);
}

export function deleteClientRequest(id) {
  return api.delete(`/api/client-requests/${id}/`);
}

export function sendClientRequest(id) {
  return api.post(`/api/client-requests/${id}/send/`, {});
}

export function cancelClientRequest(id) {
  return api.post(`/api/client-requests/${id}/cancel/`, {});
}

export function remindClientRequest(id) {
  return api.post(`/api/client-requests/${id}/remind/`, {});
}

export function getClientRequestItems(requestId) {
  return api.get(`/api/client-requests/${requestId}/items/`);
}

export function addClientRequestItem(requestId, payload) {
  return api.post(`/api/client-requests/${requestId}/items/`, payload);
}

export function patchClientRequestItem(itemId, payload) {
  return api.patch(`/api/client-requests/items/${itemId}/`, payload);
}

export function deleteClientRequestItem(itemId) {
  return api.delete(`/api/client-requests/items/${itemId}/`);
}

export function listClientRequestTemplates() {
  return api.get('/api/client-request-templates/');
}

export function createClientRequestTemplate(payload) {
  return api.post('/api/client-request-templates/', payload);
}
